import { useHistory } from 'react-router-dom';
import { Box, Divider, List, ListItem, ListItemText, makeStyles, Menu } from '@material-ui/core';
import { useAppDispatch } from '../../../store';
import { clearClient, clearMessage } from '../../../store/adviser';
import { Colors } from '../../controls/helpers';

interface MenuItem {
    href?: string;
    label: string;
    route?: string;
}

const ToolsMenu = ({ anchor, menuItems, close }: { anchor?: HTMLElement; menuItems: MenuItem[]; close: () => void; }) => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const classes = useStyles();
    return <Menu
        keepMounted
        anchorEl={anchor}
        open={Boolean(anchor)}
        getContentAnchorEl={null}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ style: { backgroundColor: Colors.White } }}>
        <List>
            {menuItems.map(({ label, route, href }, index) =>
                <Box key={index}>
                    <ListItem
                        button
                        {...{ component: href ? 'a' : 'div', href, target: href ? '_blank' : undefined }}
                        onClick={() => {
                            close();
                            if (!!route) {
                                dispatch(clearClient());
                                dispatch(clearMessage());
                                history.push(route);
                            }
                        }}>
                        <ListItemText classes={{ primary: classes.listItemText }} style={{ color: route === history.location.pathname ? Colors.Blue : Colors.DarkGrey }}>{label}</ListItemText>
                    </ListItem>
                    {index !== menuItems.length - 1 && <Divider />}
                </Box>
            )}
        </List>
    </Menu>
}

const useStyles = makeStyles({
    listItemText: {
        fontSize: '0.875rem',
        fontWeight: 500
    }
});

export default ToolsMenu;
